import { render, staticRenderFns } from "./ydfcb.vue?vue&type=template&id=29c9874b&scoped=true&"
import script from "./ydfcb.vue?vue&type=script&lang=js&"
export * from "./ydfcb.vue?vue&type=script&lang=js&"
import style0 from "./ydfcb.vue?vue&type=style&index=0&id=29c9874b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c9874b",
  null
  
)

export default component.exports